import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input, FormGroup } from 'reactstrap';
import { REQUIRED_VIN_LENGTH } from 'client/site-modules/shared/constants/appraisal/appraisal';
import { FieldError } from 'client/site-modules/shared/components/field-error/field-error';
import { VinValidationMessage } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/tabs/vin-tab/vin-validation-message';

export function VinInput({
  className = '',
  vinInputValue = '',
  onVinChange,
  isError = false,
  isVinValid = true,
  isVinValidLength = true,
  isDecodedVinInvalid = false,
  inputId = 'vin-input',
}) {
  return (
    <FormGroup
      className={classnames('styled-input form-group', className, {
        'has-danger': isError,
      })}
      noMargin
    >
      <div className="input-wrapper pos-r">
        <Input
          name="vin-number"
          id={inputId}
          type="text"
          className="form-control text-uppercase vin-number"
          value={vinInputValue}
          onChange={onVinChange}
          maxLength={REQUIRED_VIN_LENGTH}
          minLength={REQUIRED_VIN_LENGTH}
          placeholder="Enter VIN"
          aria-required
          required
          aria-describedby="vinError"
          aria-invalid={!!isError}
        />
      </div>
      <FieldError
        id="vinError"
        classes="value-error-text mt-0_5"
        error={
          <VinValidationMessage
            isError={isError}
            isVinValid={isVinValid}
            isVinValidLength={isVinValidLength}
            isDecodedVinInvalid={isDecodedVinInvalid}
          />
        }
        isLiveRegion
      />
    </FormGroup>
  );
}

VinInput.propTypes = {
  className: PropTypes.string,
  vinInputValue: PropTypes.string,
  onVinChange: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  isVinValid: PropTypes.bool,
  isVinValidLength: PropTypes.bool,
  isDecodedVinInvalid: PropTypes.bool,
  inputId: PropTypes.string,
};
